import { render, staticRenderFns } from "./SlideTipBar.vue?vue&type=template&id=5150ded8&scoped=true&"
import script from "./SlideTipBar.vue?vue&type=script&lang=js&"
export * from "./SlideTipBar.vue?vue&type=script&lang=js&"
import style0 from "./SlideTipBar.vue?vue&type=style&index=0&id=5150ded8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5150ded8",
  null
  
)

export default component.exports